import { ToastService } from '@philips-internal/oswald-ui-components';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

export default function showSuccessToast(id: string, message: string): void {
  ToastService.open({
    id: id,
    dismissible: false,
    message: MessageService.translate(message),
    level: ToastLevel.SUCCESS,
    timeout: 5000,
  });
}
